<template>
  <v-container fluid style='background-color:white'>
    <v-layout row wrap fill-height justify-center>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat>
          <br />
          <v-layout justify-center >
            <v-card-title class='headlinestyle'><strong>จัดการสินค้า</strong></v-card-title>
          </v-layout>
          <br />
        <v-layout row wrap justify-center align-end>
          <v-flex xs12 sm11 md11 lg11>
            <v-layout row wrap justify-start align-center>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>รหัสซื้อขาย</strong></p>
                <v-text-field v-model="product_no_search" outlined clearable dense v-on:input="productfilterfunction()" color="pink lighten-3"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5>
                <p style="color:#4C4C4C; font-size:90%;"><strong>ชื่อสินค้า</strong></p>
                <v-text-field v-model="name_search" outlined clearable dense v-on:input="productfilterfunction()" color="pink lighten-3"></v-text-field >
              </v-flex>
              <v-flex xs12 sm6 md3 lg3 px-5 v-for="(searchitem, i) in searchitems" :key="i">
                   <p style="color:#4C4C4C; font-size:90%;"><strong>{{searchitem.text}}</strong></p>
                    <v-combobox
                      v-model="searchitem.model"
                      :items="searchitem.items"
                      :item-text="searchitem.itemtext"
                      :item-value="searchitem.itemtext"
                      :return-object="false"
                      hide-selected
                      outlined
                      clearable
                      dense
                      multiple
                      persistent-hint
                      small-chips
                      v-on:input="productfilterfunction()"
                      color="pink lighten-3"
                    ></v-combobox>
                </v-flex>
                <v-flex xs10 sm6 md3 lg3>
                <v-layout justify-end align-center>
                  <v-flex xs5 sm5 md5 lg5>
                    <v-btn class="mx-1 addbuttonstyle" outlined color="indigo lighten-3" @click="openimportfilemodal()">
                      <v-icon>mdi-publish</v-icon>&nbsp;
                      Import
                    </v-btn>
                  </v-flex>
                  <v-flex xs6 sm6 md6 lg6 px-1>
                    <v-btn class="mx-1 addbuttonstyle" outlined color="indigo lighten-2" @click="openproductmodal('')">
                      <v-icon>mdi-plus</v-icon>&nbsp;
                      เพิ่มสินค้า
                    </v-btn>
                  </v-flex>
                </v-layout>
                </v-flex>
              </v-layout>
          <br />
          <v-data-table
            :headers="headers"
            :items="productdatas"
            :items-per-page="10"
            :page.sync="page"
            class="elevation-3"
            style="font-family: Kanit;"
            :loading="loading"
            :server-items-length="itemlength"
            @update:page="pagechange"
            @update:items-per-page="itempagechange"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100]
            }"
          >
          <template v-slot:body="{ items }">
                <tbody>
                  <tr
                    v-for="item in items"
                    :key="item._id"
                    style="cursor: pointer;"
                    align='center'
                  >
                  <td @click="openproductmodal(item._id)">{{ item.product_no }}</td>
                  <td @click="openproductmodal(item._id)">
                    <v-container class="con">
                    <v-img
                      class="white--text align-center"
                      style="height:100px; width:130px;"
                      :src="item.image"
                      v-if="item.image"
                    ></v-img></v-container></td>
                  <td @click="openproductmodal(item._id)">{{ item.name }}</td>
                  <td @click="openproductmodal(item._id)">{{ item.price }}</td>
                  <td @click="openproductmodal(item._id)">{{ item.type }}</td>
                  <td>
                    <v-btn class="ma-2" outlined small fab color="pink lighten-2" @click="openproductmodal(item._id)">
                      <v-icon meduim>mdi-pencil</v-icon>
                    </v-btn>
                     <v-btn class="ma-2" outlined small fab color="red" @click="deleteproduct(item.product_no, item._id, item.name)">
                      <v-icon meduim>mdi-delete-forever</v-icon>
                    </v-btn>
                  </td>
                  </tr>
                </tbody>
          </template>
          </v-data-table>
          </v-flex>
        </v-layout>
        <br />
        <br />
        <Productmodal :parentgetdata="getdata" />
        <Importfilemodal :productparentgetdata="getdata" />
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Productmodal from '@/components/Productmodal'
import Importfilemodal from '@/components/Importfilemodal'
import swal from 'sweetalert'
import axios from 'axios'
import { sync } from 'vuex-pathify'
import numeral from 'numeral'
export default {
  components: {
    Productmodal,
    Importfilemodal
  },
  data: () => ({
    headers: [
      { text: 'รหัสซื้อขาย', align: 'center', sortable: false, value: 'product_no' },
      { text: 'รูปสินค้า', align: 'center', sortable: false, value: 'image' },
      { text: 'ชื่อสินค้า', align: 'center', sortable: false, value: 'name' },
      { text: 'ราคา', align: 'center', sortable: false, value: 'price' },
      { text: 'ประเภท', align: 'center', sortable: false, value: 'type' },
      { text: 'แก้ไข/ลบ', value: 'action', sortable: false, align: 'center' }
    ],
    productdatas: [],
    productdata_view: [],
    product_no_search: '',
    name_search: '',
    searchitems: [
      { text: 'ประเภท', items: ['ชิ้น', 'ถุง', 'กล่อง'], itemtext: 'type', model: [] }
    ],
    loading: false,
    page: 1,
    itempage: 10,
    itemlength: 0
  }),
  created () {
    if (this.$cookies.get('token') !== '') {
      if (this.$cookies.get('status') === 'super admin') {
        this.getdata()
      } else {
        this.$router.push('/')
      }
    } else {
      this.$router.push('/')
    }
  },

  methods: {
    pagechange (p) {
      this.page = p
      this.getdata()
    },
    itempagechange (itp) {
      this.itempage = itp
      this.getdata()
    },
    async getdata () {
      try {
        this.currentproductdata = ''
        this.currentgrouppriceid = ''
        // this.loading = true
        let { data } = await axios.post(`${process.env.VUE_APP_API}/product/get`, {
          productno: this.product_no_search || '',
          productname: this.name_search || '',
          producttype: this.searchitems[0].model || ''
        }, {
          headers: {
            Authorization: this.$cookies.get('token'),
            limit: this.itempage,
            skip: (Number(this.page) - 1) * Number(this.itempage)
          }
        })
        this.itemlength = Number(data.productlength) || 0
        this.productdatas = data.productdata.map(pd => {
          pd.image = pd.image ? `${process.env.VUE_APP_API}${pd.image}` : ''
          pd.price = numeral(pd.price).format('0,0.00')
          return { ...pd }
        })
        // this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    openproductmodal (id) {
      this.productmodal = true
      this.currentproductdata = id ? JSON.stringify(this.productdatas.find(pd => pd._id === id)) : ''
    },
    openimportfilemodal () {
      this.importfilemodal = true
      this.importmodel = 1
    },
    async deleteproduct (no, id, name) {
      try {
        await swal({
          title: `คุณแน่ใจที่จะลบสินค้า ${name} ?`,
          icon: 'warning',
          buttons: ['ยกเลิก', 'ลบ'],
          dangerMode: true
        }).then(async (willDelete) => {
          if (willDelete) {
            let { data } = await axios.delete(`${process.env.VUE_APP_API}/product/delete/${id}`, {
              headers: {
                Authorization: this.$cookies.get('token')
              }
            })
            if (data) {
              await swal(`สินค้า ${name} ถูกลบแล้ว!`, {
                icon: 'success',
                buttons: 'ตกลง'
              })
              this.getdata()
            }
          }
        })
      } catch (error) {
        await swal({
          title: `ระบบผิดพลาด`,
          text: 'กรุณาลองอีกครั้งในภายหลัง',
          icon: 'warning',
          buttons: 'ตกลง',
          dangerMode: true
        })
      }
    },
    async productfilterfunction () {
      this.page = 1
      await this.getdata()
    }
  },
  computed: {
    productmodal: sync('productmodal'),
    currentproductdata: sync('currentproductdata'),
    currentgrouppriceid: sync('currentgrouppriceid'),
    importfilemodal: sync('importfilemodal'),
    importmodel: sync('importmodel')
  }
}
</script>

<style>
.container {
  margin: 5px;
}
.container .con {
  margin: 0px;
}
.headlinestyle {
  font-family: 'Kanit';
  font-style: normal;
  font-weight: normal;
  font-size: 30px;
  line-height: 54px;
  color: #000000;
}
.v-data-table th {
  height: 60px !important;
}
.addbuttonstyle {
  font-family: 'Kanit';
  font-weight: bold;
}
</style>

<style scoped>
td {
  max-width: 90px;
  overflow: hidden;
  text-overflow: clip;
  white-space: nowrap;
}
</style>
